/*global d3 */
'use strict';

const X_OFFSET = 19;
const Y_OFFSET = 11.5;
const SCALE = 7.5;
const QUERY_SHOT_INFO_ELEMENT = '#shot-info';
const QUERY_SHOT_RACKET_ELEMENT = '#shot-racket';

export default class ShotDataView {
  constructor (swingTypeConstants) {
    this.impactPoints = this.getImpactPoints();
    this.shots = null;
    this.drawingShotIndex = -1;
    this.drawingShotTime = 0;
    this.startedDate = 0;
    this.endedDate = 0;
    this.swingTypeConstants = swingTypeConstants;

    let labelPositionY = 2;
    let valuePositionY = labelPositionY + 12;
    let unitPositionY = valuePositionY + 10;

    this.hide();

    // racket view
    let svg = d3.select(QUERY_SHOT_RACKET_ELEMENT).append('svg')
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .attr('viewBox', '0 0 67 67')
      .classed('svg-content', true);
    svg.append('image', 'g')
      .attr('xlink:href', './res/st_movie/movie_play_racquet.png')
      .attr('width', '100%')
      .attr('height', '100%');

    // impact point
    this.shotsvg = svg.append('g')
      .attr({
        transform: function (d) {
          return 'translate(' +
          -10 + ',' +
          -10 + ')';
        }
      });
    this.shotsvg.append('circle')
      .attr({
        'r': function (d) { return 6; },
        'fill': function (d, i) { return '#fcff35'; }
      });

    // shot info
    svg = d3.select(QUERY_SHOT_INFO_ELEMENT).append('svg')
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .attr('viewBox', '0 0 375 45')
      .classed('svg-content', true);
    svg.append('rect')
      .attr({
        'x': 0,
        'y': 0,
        'width': '100%',
        'height': '100%',
        'fill': 'black',
        'opacity': 0.5
      });

    // swing type
    this.swingType = svg.append('text')
      .attr({
        'x': '70',
        'y': '8',
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge'
      })
      .classed('shot-type-value', true);
    this.swingType.text('');
    this.subSwingType = svg.append('text')
      .attr({
        'x': '70',
        'y': '22.5',
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge'
      })
      .classed('shot-type-value', true);
    this.subSwingType.text('');

    // spin
    svg.append('text')
      .attr({
        'x': '166',
        'y': labelPositionY,
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge'
      })
      .text('ボール回転')
      .classed('spin-label', true);
    this.spin = svg.append('text')
      .attr({
        'x': '166',
        'y': valuePositionY,
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge'
      })
      .classed('spin-value', true);
    this.spin.text('0');

    // swing speed
    svg.append('text')
      .attr({
        'x': '222',
        'y': labelPositionY,
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge'
      })
      .text('スイング速度')
      .classed('swing-speed-label', true);
    this.swingSpeed = svg.append('text')
      .attr({
        'x': '263',
        'y': valuePositionY,
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge',
        'text-anchor': 'end'
      })
      .classed('swing-speed-value', true);
    this.swingSpeed.text('0');
    svg.append('text')
      .attr({
        'x': '265',
        'y': unitPositionY,
        'font-size': '9',
        'fill': '#ffffff',
        'stroke-width': '1',
        'dominant-baseline': 'text-before-edge'
      })
      .text('km/h');

    // ball speed
    svg.append('text')
      .attr({
        'x': '290',
        'y': labelPositionY,
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge'
      })
      .text('ボール速度')
      .classed('ball-speed-label', true);
    this.ballSpeed = svg.append('text')
      .attr({
        'x': '331',
        'y': valuePositionY,
        'fill': '#ffffff',
        'dominant-baseline': 'text-before-edge',
        'text-anchor': 'end'
      })
      .classed('ball-speed-value', true);
    this.ballSpeed.text('0');
    svg.append('text')
      .attr({
        'x': '333',
        'y': unitPositionY,
        'font-size': '9',
        'fill': '#ffffff',
        'stroke-width': '1',
        'dominant-baseline': 'text-before-edge'
      })
      .text('km/h');
  }

  getImpactPoints () {
    let basePoints = [
      [0, 4], [0, 3], [0, 2], [0, 1],
      [1, 5], [1, 4], [1, 3], [1, 2], [1, 1], [1, 0],
      [2, 5], [2, 4], [2, 3], [2, 2], [2, 1], [2, 0],
      [3, 5], [3, 4], [3, 3], [3, 2], [3, 1], [3, 0],
      [4, 4], [4, 3], [4, 2], [4, 1]
    ];

    return basePoints.map((point) => {
      return {
        x: X_OFFSET + (point[0] * SCALE),
        y: Y_OFFSET + (point[1] * SCALE)
      };
    });
  }

  appendShots (shots, start, end) {
    this.startedDate = start;
    this.endedDate = end;
    if (!shots) {
      console.error('shot response timing issue');
    }
    if (shots.length === 0) {
      console.log('empty shot data');
      return;
    }

    this.show();

    if (end < shots[0].date || shots[shots.length - 1].date < start) {
      console.error('video range mismatched');
      return;
    }
    let startIndex = -1;
    let endIndex = -1;
    for (let i = 0; i < shots.length; i++) {
      let shotDate = new Date(shots[i].shotDate).toISOString();
      if (start < shotDate) {
        startIndex = i;
        break;
      }
    }
    for (let j = startIndex; j < shots.length; j++) {
      let shotDate = new Date(shots[j].shotDate);
      if (end < shotDate) {
        endIndex = j;
        break;
      }
      if (j === (shots.length - 1)) {
        endIndex = shots.length;
        break;
      }
    }
    this.shots = shots.slice(startIndex, endIndex);
  }

  updateShotData (time) {
    // shot dataがない場合はなにもしない
    if (!this.shots) { return; }
    let lastShotIndex = this.shots.length - 1;

    // 再生が戻った時は最初のshotから検索
    if (time * 1000 < this.drawingShotTime) {
      this.clearShot();
      this.drawingShotIndex = -1;
    }

    // 動画の再生時間が次に描画するショットの時間以上になったときに、ショットデータ描画を行う
    if (this.drawingShotIndex === lastShotIndex ||
        time * 1000 < new Date(this.shots[this.drawingShotIndex + 1].shotDate) - new Date(this.startedDate)) {
      return;
    }

    for (let i = this.drawingShotIndex + 1; i <= lastShotIndex; i++) {
      let shotDate = new Date(this.shots[i].shotDate);
      let startedDate = new Date(this.startedDate);
      if (i === lastShotIndex || time * 1000 < new Date(this.shots[i + 1].shotDate) - startedDate) {
        this.drawingShotIndex = i;
        this.drawingShotTime = shotDate - startedDate;
        this.drawShotData(this.shots[i].summaryData);
        break;
      }
    }
  }

  drawShotData (shotSummaryData) {
    let swingType = this.swingTypeConstants.getLabel([shotSummaryData.swing.type]);
    this.swingType.text(swingType.split(' ')[0]);
    this.subSwingType.text(swingType.split(' ')[1]);
    this.swingSpeed.text(Math.round(shotSummaryData.swing.speed));
    this.ballSpeed.text(Math.round(shotSummaryData.impact.speed));
    let spin =
      (shotSummaryData.impact.spin >= 2850) ? 10
      : (shotSummaryData.impact.spin >= 2550) ? 9
      : (shotSummaryData.impact.spin >= 2250) ? 8
      : (shotSummaryData.impact.spin >= 1950) ? 7
      : (shotSummaryData.impact.spin >= 1650) ? 6
      : (shotSummaryData.impact.spin >= 1350) ? 5
      : (shotSummaryData.impact.spin >= 1050) ? 4
      : (shotSummaryData.impact.spin >= 750) ? 3
      : (shotSummaryData.impact.spin >= 450) ? 2
      : (shotSummaryData.impact.spin >= 150) ? 1
      : (shotSummaryData.impact.spin >= -150) ? 0
      : (shotSummaryData.impact.spin >= -450) ? -1
      : (shotSummaryData.impact.spin >= -750) ? -2
      : (shotSummaryData.impact.spin >= -1050) ? -3
      : (shotSummaryData.impact.spin >= -1350) ? -4
      : (shotSummaryData.impact.spin >= -1650) ? -5
      : (shotSummaryData.impact.spin >= -1950) ? -6
      : (shotSummaryData.impact.spin >= -2250) ? -7
      : (shotSummaryData.impact.spin >= -2550) ? -8
      : (shotSummaryData.impact.spin >= -2850) ? -9
      : -10;
    if (spin > 0) {
      spin = '+' + spin;
    }
    this.spin.text(spin);
    let spot = shotSummaryData.impact.spot;
    this.shotsvg.attr({
      transform: (d) => {
        return 'translate(' +
         this.impactPoints[spot].x + ',' +
         this.impactPoints[spot].y + ')';
      }
    });
  }

  clearShot () {
    // impact pointの位置を再生前に戻す
    this.shotsvg.attr({
      transform: (d) => {
        return 'translate(' +
         -10 + ',' +
         -10 + ')';
      }
    });
    // 描画されたショット情報を空文字で更新
    this.swingType.text('');
    this.subSwingType.text('');
    this.spin.text('0');
    this.ballSpeed.text('0');
    this.swingSpeed.text('0');
  }

  hide () {
    d3.select(QUERY_SHOT_INFO_ELEMENT)
      .style({ 'visibility': 'hidden' });
    d3.select(QUERY_SHOT_RACKET_ELEMENT)
      .style({ 'visibility': 'hidden' });
  }

  show () {
    d3.select(QUERY_SHOT_INFO_ELEMENT)
      .style({ 'visibility': 'visible' });
    d3.select(QUERY_SHOT_RACKET_ELEMENT)
      .style({ 'visibility': 'visible' });
  }
}



// WEBPACK FOOTER //
// ./app/lib/shot-data-view.es6